<template>
    <div class="transfer-plan-outbound" style="position: relative">
        <div
            v-if="type == 'query'"
            class="button-container margin-top-15 clearfix"
        >
            <div class="pull-left">
                <Button
                    v-if="formData.status == 0 && handleAuth('fbb.transfer.outboundedit')"
                    class="margin-right-15"
                    type="success"
                    @click="handleOperate('confirm')"
                    >确认</Button
                >
                <Button
                    v-if="formData.status == 0 && handleAuth('fbb.transfer.outboundedit')"
                    class="margin-right-15"
                    type="error"
                    @click="handleOperate('cancel')"
                    >取消</Button
                >
            </div>
            <div class="pull-right">
                <Button type="default" @click="cancel">返回</Button>
            </div>
        </div>
        <compWrapper theme="primary" title="基础信息">
            <div class="margin-top-15">
                <compFormQuery
                    v-if="type == 'query'"
                    :formdata="getBase"
                    :value="formData"
                    placeholder="--"
                ></compFormQuery>
                <compFormEdit
                    ref="editForm"
                    v-else
                    v-model="formData"
                    :formdata="getBase"
                ></compFormEdit>
            </div>
            <template v-if="type == 'edit'" slot="footer">
                <Button type="primary" @click="save(0)">保存</Button>
                <Button class="margin-left-15" type="success" @click="save(1)"
                    >确认</Button
                >
                <Button class="margin-left-15" type="default" @click="cancel"
                    >取消</Button
                >
            </template>
        </compWrapper>
        <compWrapper theme="info" title="出库信息">
            <div
                v-if="type != 'query'"
                class="margin-top-15"
                style="display: flex"
            >
                <Form
                    inline
                    ref="outboundForm"
                    :model="outboundData"
                    :labelWidth="100"
                >
                    <FormItem label="SKU" prop="sku" :rules="required">
                        <Select
                            v-model="outboundData.sku"
                            filterable
                            @on-change="handleChangeSku"
                        >
                            <Option
                                v-for="item in skuList"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="装箱入数" prop="qty" :rules="required">
                        <InputNumber
                            class="width-100per"
                            :min="0"
                            :precision="0"
                            v-model="outboundData.qty"
                        ></InputNumber>
                    </FormItem>
                    <FormItem
                        label="箱数"
                        prop="containerQty"
                        :rules="required"
                    >
                        <InputNumber
                            class="width-100per"
                            v-model="outboundData.containerQty"
                            :min="0"
                            :precision="0"
                        ></InputNumber>
                    </FormItem>
                </Form>
                <div class="margin-left-20">
                    <Button type="primary" @click="addOne">添加</Button>
                    <Button
                        class="margin-left-15"
                        type="success"
                        @click="importOutbound"
                        >导入</Button
                    >
                    <Button
                        class="margin-left-15"
                        type="success"
                        @click="fastOutbound"
                        >一键出库</Button
                    >
                </div>
            </div>
            <div v-if="type != 'query'" class="margin-left-15">
                <Button @click="deleteItem">删除</Button>
                <Button class="margin-left-15" @click="clearAll">清空</Button>
            </div>
            <Table
                class="
                    margin-top-15
                    margin-left-15
                    margin-right-15
                    margin-bottom-15
                "
                size="small"
                border
                :columns="outboundColumns"
                :data="outboundList"
                @on-selection-change="handleColumnsSelect"
            ></Table>
        </compWrapper>
        <compWrapper
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <compModal v-model="operate.show" v-bind="operate">
            <component
                :is="operate.component"
                v-bind="operate.props"
                v-on="operate.on"
            ></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpTransferOutboundDetail,
    HttpGetSKUList,
    HttpUpdateOutbound,
    HttpTransferOutboundConfirm,
    HttpTransferOutboundCancel,
    HttpTransferOutboundFastOut,
    HttpTransferOutboundAddProduct,
    HttpTransferOutboundClear,
    HttpTransferOutboundDeleteById,
} from "@/service/transferplan";
import ajaxMixin from "../ajaxmixin";
import mixin from "../mixin";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype"],
    mixins: [mixin, ajaxMixin],
    data() {
        return {
            id: this.activeid || this.$route.query.id,
            type: this.querytype || this.$route.params.type,
            formData: {},
            outboundData: {
                containerQty: null,
                qty: null,
            },
            skuList: [],
            skuItem: {},
            selectedData: [],
            outboundList: [],
            logList: [],
            operate: {
                show: false,
            },
            loading: false,
        };
    },
    async created() {
        this.loading = true;
        await this.getDetail();
        await this.getMixinWarehouse(true);
        this.loading = false;
    },
    computed: {
        ...mapGetters("dictionary", [
            "getSelfmanageorgList",
            "getCusproductList",
            "getFilterDisabledWarehouse",
        ]),
        required() {
            return [
                {
                    required: true,
                    message: "此项必填",
                },
            ];
        },
        getBase() {
            return [
                {
                    label: "转运出库单号",
                    key: "transitOutboundOrderNo",
                    query: true,
                },
                {
                    label: "状态",
                    key: "status",
                    tag: "vSelect",
                    options: this.getBoundStatus,
                    query: true,
                },
                {
                    label: "转运计划单号",
                    key: "transitPlanOrderNo",
                    query: true,
                },
                {
                    label: "来源单号",
                    key: "sourceNo",
                    query: this.type != "edit",
                    required: false,
                },
                {
                    label: "仓库",
                    key: "orgWarehouseId",
                    tag: "vSelect",
                    options: this.mixinWarehouseList,
                    query: true,
                },
                {
                    label: "项目",
                    key: "lineId",
                    tag: "vSelect",
                    options: this.getCusproductList,
                    query: true,
                },
                // {
                //     label: "集装箱号",
                //     key: "containerNo",
                //     query: true,
                // },
                {
                    label: "托盘数",
                    key: "palletQty",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                        precision: 0,
                    },
                    query: this.type != "edit",
                    required: false,
                },
                {
                    label: "箱数",
                    key: "containerQty",
                    query: true,
                    // tag: "vInputNumber",
                    // props: {
                    //     min: 0,
                    //     precision: 0
                    // },
                },
                {
                    label: "贴标数",
                    key: "labelQty",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                        precision: 0
                    },
                    query: this.type != "edit",
                    required:false,
                },
                {
                    label: "备注",
                    key: "remark",
                    tag: "vTextarea",
                    query: this.type != "edit",
                    required: false,
                },
            ];
        },
        outboundColumns() {
            let column = [
                {
                    type: "selection",
                    width: 55,
                },
                {
                    title: "SKU",
                    key: "sku",
                },
                {
                    title: "装箱入数",
                    key: "qty",
                },
                {
                    title: "箱数",
                    key: "containerQty",
                },
                {
                    title: "更新时间",
                    key: "updatedAt",
                },
            ];
            if (this.type == "query") {
                column.splice(0, 1);
            }
            return column;
        },
        logcolumn() {
            return [
                {
                    title: this.$t("global.common.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "updatedName",
                },
                {
                    title: this.$t("global.common.operate_type", {
                        defaultValue: "操作类型",
                    }),
                    key: "operateType",
                    render: (h, { row }) => {
                        let operateName = this.getOperateType.filter((item) => {
                            return row.operateType == item.value;
                        })[0];
                        return (
                            <div>{operateName ? operateName.label : "--"}</div>
                        );
                    },
                },
                {
                    title: "备注",
                    key: "remark",
                },
                {
                    title: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: "createdAt",
                },
            ];
        },
    },
    methods: {
        async fastOutbound() {
            this.loading = true;
            await HttpTransferOutboundFastOut({
                id: this.id,
            }).then(
                (res) => {
                    let dataList = res.data;
                    this.outboundList = dataList;
                    // for (let i = 0; i < dataList.length; i++) {
                    //     let hasSame = false;
                    //     this.outboundList.map((item) => {
                    //         if (
                    //             item.sku == dataList[i].sku &&
                    //             item.qty == dataList[i].qty
                    //         ) {
                    //             hasSame = true;
                    //             item.containerQty =
                    //                 parseInt(item.containerQty) +
                    //                 parseInt(dataList.containerQty);
                    //         }
                    //     });
                    //     if (!hasSame) {
                    //         this.outboundList.push({
                    //             ...dataList[i],

                    //             updatedAt: Dates.stringify(
                    //                 new Date(),
                    //                 "yyyy-mm-dd HH:MM:SS"
                    //             ),
                    //         });
                    //     }
                    // }
                    this.handleTotal();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        handleTotal() {
            let total = 0;
            this.outboundList.map((item) => {
                total += parseInt(item.containerQty);
            });
            this.formData.containerQty = total;
        },
        handleOperate(type) {
            switch (type) {
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "确认",
                        width: 460,
                        showDesc: false,
                        params: { id: this.id },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 22,
                                labelWidth: 100,
                                label: this.$t("global.common.notes", {
                                    defaultValue: "备注",
                                }),
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpTransferOutboundConfirm,
                        callback: () => {
                            this.refresh();
                        },
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t("global.common.operate_cancel", {
                            defaultValue: "取消",
                        }),
                        width: 460,
                        showDesc: false,
                        params: { id: this.id },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 22,
                                labelWidth: 100,
                                label: "取消原因",
                            },
                        ],
                        ajaxRequest: HttpTransferOutboundCancel,
                        callback: () => {
                            this.refresh();
                        },
                    };
                    break;
            }
        },
        async refresh() {
            this.loading = true;
            await this.getDetail();
            this.loading = false;
            this.$emit("on-update");
        },
        handleChangeSku(sku) {
            if (!sku) return (this.skuItem = {});
            // console.log("sku", sku);
            let skuItem = this.skuList.filter((item) => {
                return item.value == sku;
            })[0];
            // console.log("skuItem", skuItem);
            this.skuItem = skuItem;
        },
        async getDetail() {
            await HttpTransferOutboundDetail({
                id: this.id,
            }).then(
                (res) => {
                    // console.log(res);
                    let { itemEntities, orderLogList, ...formData } = {
                        ...res.data,
                    };
                    this.outboundList = itemEntities || [];
                    this.logList = orderLogList || [];
                    this.formData = formData;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );

            await HttpGetSKUList({
                id: this.formData.transitPlanOrderId,
            }).then(
                (res) => {
                    // console.log("sku", res);
                    this.skuList = res.data.map((item) => {
                        return {
                            value: item.sku,
                            label: item.sku,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.handleTotal();
        },
        importOutbound() {
            this.operate = {
                show: true,
                title: "导入明细",
                component: "compMutiUpload",
                showFooter: false,
                width: 450,
                props: {
                    action:
                        process.env.VUE_APP_APIURL_FBB +
                        "/api/v2/TransitOutbound/importOrder",
                    name: "multipartFile",
                    data: {
                        transitPlanOrderId: this.formData.transitPlanOrderId,
                        id: this.id,
                    },
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_FBB +
                                "/api/v2/TransitOutbound/itemTemplate",
                            "download"
                        );
                    },
                    formatter: (res) => {
                        return res.data;
                    },
                },
                on: {
                    "on-success": (data) => {
                        // data.map((item) => {
                        // let hasSame = false;
                        // this.outboundList.map((skuItem) => {
                        //     hasSame = true;
                        //     if (
                        //         skuItem.sku == item.sku &&
                        //         skuItem.qty == item.qty
                        //     ) {
                        //         skuItem.containerQty =
                        //             parseInt(skuItem.containerQty) +
                        //             parseInt(item.containerQty);
                        //     }
                        // });
                        // if (!hasSame) {
                        //     this.outboundList.push({
                        //         ...item,
                        //         updatedAt: Dates.stringify(
                        //             new Date(),
                        //             "yyyy-mm-dd HH:MM:SS"
                        //         ),
                        //     });
                        // }
                        //     this.outboundList.push(item);
                        // });
                        this.outboundList = data;
                        this.operate.show = false;
                        this.handleTotal();
                    },
                    "on-cancel": () => {
                        this.operate.show = false;
                    },
                },
            };
        },
        handleColumnsSelect(selection) {
            this.selectedData = selection;
        },
        async addOne() {
            let flag = true;
            this.$refs.outboundForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            // let hasSame = false;
            // this.outboundList.map((item) => {
            //     if (
            //         item.sku == this.outboundData.sku &&
            //         item.qty == this.outboundData.qty
            //     ) {
            //         hasSame = true;
            //         item.containerQty =
            //             parseInt(item.containerQty) +
            //             parseInt(this.outboundData.containerQty);
            //     }
            // });
            // if (!hasSame) {
            //     this.outboundList.push({
            //         ...this.outboundData,
            //         productId: this.skuItem.attach.productId,
            //         updatedAt: Dates.stringify(
            //             new Date(),
            //             "yyyy-mm-dd HH:MM:SS"
            //         ),
            //     });
            // }
            this.loading = true;
            await HttpTransferOutboundAddProduct({
                id: this.id,
                ...this.outboundData,
                productId: this.skuItem.attach.productId,
            }).then(
                (res) => {
                    this.outboundList = res.data.map((item) => {
                        return {
                            ...item,
                        };
                    });
                    this.handleTotal();
                    this.$refs.outboundForm.resetFields();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        deleteItem() {
            if (!this.selectedData.length)
                return this.$VMessage.warning("请选择需要删除的项");
            this.operate = {
                show: true,
                alert: "error",
                title: "删除",
                ajaxRequest: async () => {
                    let deleteIds = [];
                    this.selectedData.map((deleteItem) => {
                        // this.outboundList.map((item, index) => {
                        //     if (
                        //         deleteItem.sku == item.sku &&
                        //         deleteItem.qty == item.qty &&
                        //         deleteItem.containerQty ==
                        //             deleteItem.containerQty
                        //     ) {
                        //         this.outboundList.splice(index, 1);
                        //     }
                        // });
                        deleteIds.push(deleteItem.id);
                    });
                    await HttpTransferOutboundDeleteById({
                        ids: deleteIds,
                    }).then(
                        (res) => {
                            this.outboundList = res.data.map((item) => {
                                return item;
                            });
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                    this.handleTotal();
                },
            };
        },
        clearAll() {
            if (!this.outboundList.length) return;
            this.operate = {
                show: true,
                title: "清空",
                alert: "error",
                ajaxRequest: async () => {
                    await HttpTransferOutboundClear({
                        id: this.id,
                    }).then(
                        (res) => {
                            this.outboundList = [];
                            this.selectedData = [];
                            this.handleTotal();
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        cancel() {
            if (!this.$route.query.id) {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "transferPlanOutboundList",
                });
            }
        },
        async save(type) {
            await this.$refs.editForm.validate();
            this.loading = true;
            console.log('formData',this.formData);
            await HttpUpdateOutbound({
                ...this.formData,
                transitOrderItemModels: this.outboundList,
                id: this.id,
            }).then(
                async (res) => {
                    if (!type) {
                        this.$VMessage.success(res.message);
                        this.cancel();
                    } else {
                        await HttpTransferOutboundConfirm({
                            id: this.id,
                        }).then(
                            (res) => {
                                this.$VMessage.success(res.message);
                                this.cancel();
                            },
                            (err) => {
                                this.$VMessage.error(err.message);
                            }
                        );
                    }
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>
